import axios, { type AxiosError } from "axios";

const API_BASE = import.meta.env.VITE_API_URL || "/api";
// If the env points at a bare origin, append /api.
const baseURL = /^https?:\/\//.test(API_BASE) ? `${API_BASE.replace(/\/+$/, "")}/api` : API_BASE;

export const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15_000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.response.use(
  (response) => response,
  (err: AxiosError) => {
    if (err.response?.status === 401 && typeof window !== "undefined") {
      const here = window.location.pathname;
      if (here !== "/auth/signin" && !here.startsWith("/auth/")) {
        window.location.assign(`/auth/signin?from=${encodeURIComponent(here)}`);
      }
    }
    return Promise.reject(err);
  },
);

/** Base URL ending with `/api` — use for direct <a href> link construction
 *  (the axios `api` instance already uses this internally for fetch calls).
 *  This export normalises across the 3 deploy modes:
 *    - dev (no VITE_API_URL):       "/api"
 *    - prod Docker (VITE_API_URL=/api): "/api"
 *    - absolute origin:             "https://map.hightekers.com/api"
 *  See docs/fix-export-url-double-api/ for the rationale. */
export const apiBaseUrl = baseURL;

export type ApiErrorBody = { error?: string; detail?: string; critical?: boolean };

export function extractApiError(err: unknown): string {
  const ax = err as AxiosError<ApiErrorBody>;
  return (
    ax.response?.data?.detail ||
    ax.response?.data?.error ||
    ax.message ||
    "Unexpected error. Please try again."
  );
}
